import { Model } from '@app/shared/model-system';
import { property } from '@app/shared/model-system/property';
import { Division } from '@shared/models/divisions/division';
import { get } from 'lodash';

export interface IContact {
  address: string;
  mediaType: MediaType;
  type: ContactType;
  extension?: string;
}

export enum MediaType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS'
}

export enum ContactType {
  HOME = 'HOME',
  MAIN = 'MAIN',
  MOBILE = 'MOBILE',
  PRIMARY = 'PRIMARY',
  WORK = 'WORK',
  WORK2 = 'WORK2',
  WORK3 = 'WORK3',
  WORK4 = 'WORK4'
}

/** User model using the model system */
export class User extends Model {
  // required: true # always serialized
  @property({}) public id: string;
  @property({}) public name: string;
  @property({}) public email: string;
  @property({
    track: false, // reference only. use Station model to update
    deserialize: (raw) => get(raw, 'station.defaultStation.id')
  })
  public defaultStationId: string;

  @property({}) public status: any;
  @property({}) public title: string;
  @property({}) public department: string;
  @property({}) public userImages: any[];
  @property({}) public username: string;
  @property({}) public voicemailEnabled: boolean;
  @property({
    // deserialize: (raw) => api.get...
  })
  public roles: any[];

  @property({}) public selfUri: string;

  @property({
    // deserialize: (raw) => api.get...
  })
  public permissions: string[];

  @property({}) public chat: any;

  @property() public version: number;

  @property() public addresses: IContact[];

  @property() public divisionId: string;

  public static get idAttribute(): string {
    return 'id';
  }
}
